import { ObjetKStatusCode, enumValue } from '@siclop/kstone-vue'
import { LeaveCategory } from '../enums'

export class LeaveType extends ObjetKStatusCode {
  category: LeaveCategory = LeaveCategory.PaidLeave
  color: string = ''
  requiresDocument: boolean = false
  maxConsecutiveDays?: number
  isPaid: boolean = true
  deductsFromBalance: boolean = true
  /** Droit annuel en jours (null : sans droit annuel, ex. absence non décomptée). */
  annualEntitlement: number | null = null
  /** Acquisition mois par mois (congés payés) plutôt qu'en une fois en début de période. */
  accruesMonthly: boolean = false

  constructor(data?: Partial<LeaveType>) {
    super(data)
    if (data) {
      this.category = enumValue(LeaveCategory, data.category, LeaveCategory.PaidLeave)
      this.color = data.color ?? ''
      this.requiresDocument = data.requiresDocument ?? false
      this.maxConsecutiveDays = data.maxConsecutiveDays
      this.isPaid = data.isPaid ?? true
      this.deductsFromBalance = data.deductsFromBalance ?? true
      this.annualEntitlement = data.annualEntitlement ?? null
      this.accruesMonthly = data.accruesMonthly ?? false
    }
  }
}
